<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14xCpvE/tc-custom/9781439677742.jpg?1704887001502" alt="This image is the cover for the book Celebrating Southern Appalachian Food, American Palate"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Celebrating Southern Appalachian Food, American Palate
      </h1>
      <p class="bookDescription body article font2">
        <p>High country cooking fit to grace any table. Southern Appalachia has a rich culinary tradition. Generations of passed down recipes offer glimpses into a culture that has long been defined, in considerable measure, by its food. Take a journey of pure delight through this highland homeland with stories of celebrations, Sunday dinners and ordinary suppers. The narrative material and scores of recipes offered here share a deep love of place and a devotion to this distinctive cuisine. The end result is a tempting invitation, in the vernacular of the region, to "pull up a chair and take nourishment." Authors Jim Casada and Tipper Pressley, both natives of the region, are seasoned veterans in sharing the culinary delights of the southern highlands.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Casada, Tipper Pressley
      </h2>
      
      <p class="authorDescription body article">Jim Casada is a former university professor who now is a full-time freelance writer. He is the author or editor of dozens of books and has published thousands of articles in regional and national magazines. He writes a regular cooking column for Smoky Mountain Living magazine. Tipper Pressley has been writing about all things Appalachia since 2008 on the popular blog Blind Pig and The Acorn . Her YouTube channel, Celebrating Appalachia, further celebrates and preserves Appalachian culture. Tipper often teaches Appalachian cooking classes at locales throughout the region.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a67ca030